export default {
  EMAIL: 'Email',
  EMAIL_HINT: 'Contoh: email@fastlog.id',
  PASSWORD: 'Kata Sandi',
  REPEAT_PASSWORD: 'Ulang Kata Sandi',
  LOGIN: 'Masuk',
  ACTIVATE_ACCOUNT: 'Aktivasi Akun',
  USERNAME: 'Nama Lengkap',
  FORGOT_PASSWORD: 'Lupa Kata Sandi?',
  CREATE_ACCOUNT: 'Belum punya akun?',
  REGISTER: 'Daftar Disini',
  PHONE_NUMBER: 'No. Telepon',
  COME_IN: 'Masuk',
  ADMIN: 'Admin',
  REGISTRATION: 'Daftar',
  CONTINUE_REGISTRATION: 'Lanjut Registrasi',
  TELP: 'No. Telepon',
  INFO_REGISTRATION: 'Setelah klik Daftar maka sistem akan mengirimkan email link aktivasi ke email anda. Silahkan klik link dari email tersebut untuk melakukan aktivasi akun anda.',
  ISAGREE: 'Saya sudah membaca dan setuju dengan',
  TERMS: 'Syarat dan Ketentuan',
  FULL_NAME: 'Nama Lengkap',
  OLD_PASSWORD: 'Kata Sandi Lama',
  NEW_PASSWORD: 'Kata Sandi Baru',
  NEW_CONFIRM_PASSWORD: 'Ulang Kata Sandi Baru',
  CHANGE_PASSWORD: 'Ubah Kata Sandi',
  SUCCESS_CHANGE_PASSWORD: 'Kata Sandi Berhasil Diubah',
};
